import { useTranslation } from "react-i18next";

const useListColumns = () => {
  const { t } = useTranslation(["core"]);

  return [
    {
      Header: t("core:common.order"),
      accessor: "order",
      disableGlobalFilter: true,
    },
    {
      Header: t("core:common.name"),
      accessor: "name",
    },
    {
      Header: t("core:common.category"),
      accessor: "category",
      disableGlobalFilter: true,
    },
    {
      Header: t("core:common.url_image"),
      accessor: "imageUrl",
      disableGlobalFilter: true,
    },
    {
      Header: "",
      accessor: "actions",
      disableSortBy: true,
      disableGlobalFilter: true,
    },
  ];
};

export default useListColumns;
